import { Avatar, Box, Button, styled, Typography } from "@mui/material";
import { RowJustifySpaceBetweenFlex, RowJustifyStartFlex } from "../commons/Containers";
import { useNavigate } from "@tanstack/react-router";
import { indigo } from "@mui/material/colors";

const TitleLogo = styled(Box)(({ theme }) => ({
    textTransform: 'uppercase',
}));

const options = [{ name: 'Templates', path: '/templates' }, { name: 'Creatives', path: '/creatives' }, { name: 'Bussiness Accounts', path: '/businessaccounts' }, { name: 'Send', path: '/send' }];


export default function Navigation() {

    const navigate = useNavigate();

    return (
        <RowJustifySpaceBetweenFlex sx={{ padding: '2px', backgroundColor: indigo['400'], color:'white' }}>
            <RowJustifyStartFlex gap={1}>
                <TitleLogo>
                    <Typography variant="h6">
                        Praveya
                    </Typography>
                </TitleLogo>
                {options && options.map(option => <Button key={option.name} variant="titleOption" onClick={() => navigate({ from: '/', to: option.path })}>{option.name}</Button>)}
            </RowJustifyStartFlex>
            <RowJustifyStartFlex>
                <Avatar >

                </Avatar>
            </RowJustifyStartFlex>
        </RowJustifySpaceBetweenFlex>
    );
}